import { FILTER_SAVED } from '../actionTypes/location.types';

export function saveFilterLocation(data: object) {
  return {
    type: FILTER_SAVED,
    payload: {
      ...data,
    },
  };
}
